// extracted by mini-css-extract-plugin
export default {"actionsContainer":"absence-actions-modal_actionsContainer__2M5HD"};